export default __webpack_public_path__ + "static/media/en_fivest.88b24a0f.png";